import { Images } from 'utils';
import { screensStyle } from './styles';

export const InfoSection = ({ text, styles, note, infoText, handleSeeAll }) => {
  const classes = screensStyle();
  return (
    <div style={{ ...styles }} className={classes.infoSectionWrapper}>
      <img src={Images.info} alt='info' />
      <p>
        {note && <b>Verification Note: </b>}
        {infoText && <b>{infoText}</b>}
        {text ? text : ''}
      </p>

      {(infoText && handleSeeAll) &&
        <button onClick={handleSeeAll}>
          See All Notes
        </button>
      }
    </div>
  );
};